import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { GlobalToken } from 'antd';

import IconGreenLeaf from '@/assets/icon-green-leaf.svg?react';

import { EnergySavingsDataBox } from './DataBox.interface';

export const GetDataBox = (params: EnergySavingsDataBox) => {
  const { title, percentage, kwh, savingsMoney, savingsCO2 } = params;
  const { t } = useTranslation();

  return (
    <Container>
      <div className="data-box-title">{title}</div>
      <div className="data-container">
        <span className="percentage">{percentage}</span>
        <span className="kwh">({kwh} kWh)</span>
        {savingsMoney && <span className="savings-money">{savingsMoney}</span>}
        {savingsCO2 && (
          <>
            <IconGreenLeaf />
            <span className="savings-co2">
              <span className="number">{savingsCO2}</span>
              <span className="unit">{t('GHG')}</span>
            </span>
          </>
        )}
      </div>
    </Container>
  );
};

const Container = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: ${({ theme: { token } }) => token.marginXXL}px;

  &:last-of-type {
    margin-right: 0;
  }

  .data-box-title {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    text-transform: uppercase;
    color: ${({ theme: { token } }) => token.colorBorder};
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .data-container {
    display: flex;
    flex-direction: row;
    align-items: flex-end;

    .percentage {
      font-size: ${({ theme: { token } }) => token.fontSizeHeading2}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      width: 72px;
    }

    .kwh {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      margin-right: ${({ theme: { token } }) => token.margin}px;
      color: ${({ theme: { token } }) => token.colorTextSecondary};
    }

    .savings-money {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};

      color: ${({ theme: { token } }) => token.colorText};
      border-radius: 13.5px;
      background-color: ${({ theme: { token } }) => token.colorCyanBorderHover};
      height: 27px;
      padding: 0 ${({ theme: { token } }) => token.paddingXS}px;
      display: flex;
      align-items: center;
      margin-right: ${({ theme: { token } }) => token.margin}px;
    }

    .savings-co2 {
      .number {
        font-size: ${({ theme: { token } }) => token.fontSize}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      }

      .unit {
        color: ${({ theme: { token } }) => token.colorTextSecondary};
        margin: ${({ theme: { token } }) => token.marginXXS}px;
        font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      }
    }
  }
`;
